module.exports = __webpack_public_path__ + "assets/232d8fd053754d30e44e781aa560e4b3.png";